<div class="sunset-modal">
  <header class="headerv2">
    <h2 class="be-text-l-bold text-navy-900">
      The Best Egg Card App is going away after December 31st
    </h2>
    <button class="btn-nude icon-btn" mat-dialog-close>
      <svg class="icon-close">
        <use [attr.href]="'assets/icons-v2/sprites.svg#close'"></use>
      </svg>
    </button>
  </header>
  <div class="content-description">
    <p class="description">
      Don’t worry - you can still check your card balance, review your
      transactions, and access all your account information on bestegg.com.
    </p>
    <p class="description">
      You'll no longer receive push notifications to your phone after Dec. 31,
      but you can set up text/email spending alerts online.
    </p>
  </div>

  <div class="content description">
    <p>
      For easy mobile access to your card account, you can add a shortcut to
      this web page on your phone's home screen.
    </p>
    <mat-accordion>
      <mat-expansion-panel (click)="setStep(0)" hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>Instructions for Safari users</mat-panel-title>
          <mat-panel-description>
            @if (step !== 0) {
              <app-icon-plus></app-icon-plus>
            }
            @if (step === 0) {
              <app-icon-minus></app-icon-minus>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>
        <ol class="list">
          <li>
            While on your phone, tap the share icon at the bottom of the screen.
          </li>
          <li>Select Add to Home Screen.</li>
          <li>Customize the name for the shortcut, if desired.</li>
          <li>Tap Add in the top-right corner.</li>
        </ol></mat-expansion-panel
        >
        <mat-expansion-panel hideToggle (click)="setStep(1)">
          <mat-expansion-panel-header>
            <mat-panel-title>Instructions for Chrome users</mat-panel-title>
            <mat-panel-description>
              @if (step !== 1) {
                <app-icon-plus></app-icon-plus>
              }
              @if (step === 1) {
                <app-icon-minus></app-icon-minus>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ol class="list">
            <li>
              While on your phone, tap the three-dot menu in the top-right corner
              of the screen.
            </li>
            <li>Select Add to Home screen.</li>
            <li>Enter a name for the shortcut, then tap Add.</li>
          </ol>
          <p class="note">
            Note: You cannot add shortcuts to your home screen via Chrome on iOS.
          </p></mat-expansion-panel
          >
        </mat-accordion>
      </div>
    </div>
